import { render, staticRenderFns } from "./xuanKuaDetail.vue?vue&type=template&id=2820bbd5&scoped=true"
import script from "./xuanKuaDetail.vue?vue&type=script&lang=js"
export * from "./xuanKuaDetail.vue?vue&type=script&lang=js"
import style0 from "./xuanKuaDetail.vue?vue&type=style&index=0&id=2820bbd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2820bbd5",
  null
  
)

export default component.exports